import {
	Button,
	Divider,
	List,
	ListItem,
	ListItemSecondaryAction,
	ListItemText,
	TextField,
	Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import config from "react-global-configuration";
import { toast } from "react-toastify";
import Backdrop from "../../Backdrop/Backdrop";
import Modal from "../../Modal/Modal";
import Carregando from "../../Pagina/Carregando";

const CarregarModelo = (props) => {
	const [modalOpen, SetModalOpen] = useState(false);
	const [loading, SetLoading] = useState(false);
	const [models, SetModels] = useState();
	const [importarForm, setImportarForm] = useState(false);
	const [confirmarExclusao, setConfirmarExclusao] = useState();
	const [modeloIdImportar, setModeloIdImportar] = useState("");

	const getModels = () => {
		SetLoading(true);
		fetch(
			config.get("url_api") + "orcamento/listar-modelos/" + props.consultorID,
			{
				method: "GET",
				headers: {
					"Content-Type": "application/json;charset=utf-8",
				},
			}
		)
			.then((res) => res.json())
			.then(
				(result) => {
					SetLoading(false);
					SetModels(result.modelos);
				},
				(error) => {
					SetLoading(false);
					alert(error);
				}
			);
	};

	const deleteModel = (modelId) => {
		fetch(config.get("url_api") + "orcamento/excluir-modelo/" + modelId, {
			method: "GET",
			headers: {
				"Content-Type": "application/json;charset=utf-8",
			},
		})
			.then((res) => res.json())
			.then(
				(result) => {
					SetLoading(false);
					SetModels(result.modelos);
					getModels();
				},
				(error) => {
					SetLoading(false);
					alert(error);
				}
			);
	};

	const importarModelo = () => {
		if (modeloIdImportar === "") {
			toast.danger("Informe o ID do modelo");
			return;
		}

		fetch(
			config.get("url_api") +
				"orcamento/importar-modelo/" +
				modeloIdImportar +
				"/" +
				props.consultorID,
			{
				method: "GET",
				headers: {
					"Content-Type": "application/json;charset=utf-8",
				},
			}
		)
			.then((res) => res.json())
			.then(
				(result) => {
					if (result.success) {
						props.carregarModelo(result.modelo.json);
						toast.success("Modelo importado: " + result.modelo.nome);
						SetModalOpen(false);
						setImportarForm(false);
						getModels();
					} else {
						SetLoading(false);
						toast.error("Modelo não encontrado com o ID informado");
					}
				},
				(error) => {
					SetLoading(false);
					toast.error("Erro ao buscar modelo");
				}
			);
	};

	const loadModels = () => {
		if (!models) {
			getModels();
		}
		SetModalOpen(true);
	};

	const copiarModeloId = (id) => {
		copiarString(id);
		toast.success("O ID do modelo foi copiado para a área de transferência.");
	};

	const copiarString = (str) => {
		var el = document.createElement("textarea");
		el.value = str;
		el.setAttribute("readonly", "");
		el.style = { position: "absolute", left: "-9999px" };
		document.body.appendChild(el);
		el.select();
		document.execCommand("copy");
		document.body.removeChild(el);
	};
	return (
		<React.Fragment>
			{modalOpen && (
				<Backdrop>
					<Modal
						title="Carregar modelo"
						onCancel={() => {
							SetModalOpen(false);
						}}
						onConfirmLabel="Carregar modelo"
						size="lg"
						onCancelTopo
					>
						{loading && <Carregando />}
						{!loading && models && models.length > 0 && (
							<React.Fragment>
								{!importarForm && (
									<>
										<Button
											size="small"
											variant="contained"
											className="mb-1"
											onClick={() => {
												setImportarForm(true);
											}}
										>
											Importar modelo
										</Button>
										<Divider />
										<List className="modelsList">
											{models.map((model) => (
												<React.Fragment key={model.id}>
													<ListItem
														onClick={() => {
															props.carregarModelo(model.json);
															SetModalOpen(false);
														}}
														button
													>
														<ListItemText primary={model.nome} />
														<ListItemSecondaryAction>
															<Button
																variant="contained"
																className="mr-1"
																onClick={() => copiarModeloId(model.id)}
															>
																Copiar
															</Button>
															{confirmarExclusao !== model.id && (
																<Button
																	color="secondary"
																	variant="contained"
																	onClick={() => setConfirmarExclusao(model.id)}
																>
																	Excluir
																</Button>
															)}
															{confirmarExclusao &&
																model.id === confirmarExclusao && (
																	<Button
																		color="secondary"
																		variant="contained"
																		onClick={() => deleteModel(model.id)}
																	>
																		Clique para excluir
																	</Button>
																)}
														</ListItemSecondaryAction>
													</ListItem>
													<Divider />
												</React.Fragment>
											))}
										</List>
									</>
								)}
								{importarForm && (
									<div className="text-center">
										<Typography variant="h5" className="mb-1">
											Cole o ID do modelo no campo abaixo e clique em Importar
										</Typography>
										<TextField
											autoFocus
											size="small"
											variant="outlined"
											placeholder="ID do modelo..."
											onChange={(event) =>
												setModeloIdImportar(event.target.value)
											}
										/>
										<div className="p-1">
											<Button
												variant="contained"
												color="primary"
												className="mr-1"
												onClick={() => {
													importarModelo();
												}}
											>
												Importar
											</Button>
											<Button
												variant="contained"
												onClick={() => {
													setImportarForm(false);
												}}
											>
												Fechar
											</Button>
										</div>
									</div>
								)}
							</React.Fragment>
						)}
					</Modal>
				</Backdrop>
			)}
			<Button
				onClick={() => loadModels()}
				variant="contained"
				color="primary"
				size="small"
				className="ml-1"
			>
				Carregar Modelo
			</Button>
		</React.Fragment>
	);
};

export default CarregarModelo;
